import {inject, Injectable} from '@angular/core';
import {AuthenticationService} from '@modules/authentication';
import {cloneDeep} from 'lodash-es';
import {AnyLinkType} from 'shared/pretty-easy-navigation/models';
import {PrettyEasyNavigationService} from 'shared/pretty-easy-navigation/pretty-easy-navigation.service';
import {GuestMenu, LearnerMenu, TrainerMenu} from './models';

type MenuName = 'guest' | 'learner' | 'trainer';

@Injectable({
    providedIn: 'root'
})
export class PrettyEasyMenuInitializerService {
    private readonly prettyEasyNavigationService = inject(PrettyEasyNavigationService);
    private readonly authService = inject(AuthenticationService);

    private currentMenu: MenuName = 'guest';

    public initializeMenu(): void {
        this.setMenu('guest');
    }

    public setMenu(menuName: MenuName): void {
        this.currentMenu = menuName;
        this.prettyEasyNavigationService.setMenu(this.buildMenu(menuName));
    }

    public refreshMenu(): void {
        this.setMenu(this.currentMenu);
    }

    public setMenuFromAccessLevel(): void {
        if (this.authService.hasLevel(['trainer', 'manager', 'administrator'])) {
            this.setMenu('trainer');
            return;
        }

        if (this.authService.hasLevel(['learner', 'parent'])) {
            this.setMenu('learner');
            return;
        }

        this.setMenu('guest');
    }

    private buildMenu(menuName: MenuName): AnyLinkType[] {
        return cloneDeep(this.getBaseMenu(menuName));
    }

    private getBaseMenu(menuName: MenuName): AnyLinkType[] {
        switch (menuName) {
            case 'learner':
                return LearnerMenu;
            case 'trainer':
                return TrainerMenu;
            default:
                return GuestMenu;
        }
    }
}
